export enum DefaultCtaListItem {
  BookOnline = 'book_online',
  Phone = 'phone',
  RequestForm = 'request_form',
  VirtualCare = 'virtual_care'
}

export const CUSTOM_LIST_ITEM_TRACKING_ID = 'custom';

// Used for functional and end-to-end tests
export const BOOK_ONLINE_BUTTON_ID = 'book-appt-online-link';
